import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter
} from '@angular/core';
// import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { BsModalService } from 'ngx-bootstrap/modal';
// import { ClipboardService } from 'ngx-clipboard';
import { CommonEnums } from 'src/app/enums/comman.enums';
// import { CommonService } from '../../services/common.service';
// import { ToasterService } from '../../services/toaster.service';
// import { API_URLS, APIENDPOINT } from '../../../../core/api-url.enum';
// import { ApiCallService } from '../../../../services/api-call.service';
// import { toTimeString } from 'src/app/modules/dashboard/utils/trim-video-utils';
// import { FFmpeg } from '@ffmpeg/ffmpeg';
// import { toBlobURL } from '@ffmpeg/util';
import { CommonService } from '@shared/services/common.service';
import { Application } from '@enums/application.enums';
import { labels } from '@modules/dashboard/components/new-post/newposts/video-trim/constant';
import { UploadService } from '@services/upload.service';
import { VIDEO_REEL_LOCATION_OPTIONS } from '@modules/edit-preference/components/privacy-password/privacy-setting-messages.enum';
import { NEW_POST_CONST } from '@modules/dashboard/components/new-post/newposts/constants';
import { base64ToImage } from '@utils/common.utils';

interface watermarkChangeProps {
  watermark: boolean;
  watermarkSettings: any
}

@Component({
  selector: 'app-video-trim',
  templateUrl: './video-trim.component.html',
  styleUrls: ['./video-trim.component.scss']
})
export class VideoTrimComponent implements OnInit {
  @ViewChild('videoElement', { static: false })
  videoElement!: ElementRef<HTMLVideoElement>;
  @ViewChild('canvasElement', { static: false })
  canvasElement!: ElementRef<HTMLCanvasElement>;
  @ViewChild('videoPlayer') videoPlayer;
  isLoading = false;
  isConfirming = false;
  videoMode = null;
  application = Application;
  modalInfo: { video: null | { file: any } } = {
    video: null
  };
  labels = labels;

  // ffmpegRef: FFmpeg;
  ffmpegLoaded = false;
  frameArray = [];
  selectedCoverImage = null;
  trimStartTime = ''; // In seconds
  trimEndTime = ''; // In seconds
  frameInterval = 1000;
  @Output() confirmed = new EventEmitter();
  @Output() confirmedWithWatermark = new EventEmitter();
  @Output() cancelled = new EventEmitter();
  isWatermark = false;
  watermark = false;
  watermarkSettings: any;
  @Output() watermarkChange = new EventEmitter<watermarkChangeProps>();
  @Output() globalWatermarkChange = new EventEmitter<any>();

  VIDEO_REEL_LOCATION_OPTIONS = VIDEO_REEL_LOCATION_OPTIONS;
  WATERMARK_HINT_VIDEO = NEW_POST_CONST.WATERMARK_HINT_VIDEO;

  constructor(
    private readonly modalService: BsModalService,
    // private readonly router: Router,
    public readonly cs: CommonService,
    // private readonly _clipboardService: ClipboardService,
    // private readonly apiCallService: ApiCallService,
    private readonly titleService: Title,
    private uploadService: UploadService,
  ) {}

  ngOnInit() {
    if (this.cs.isBrowser){
      this.modalInfo = Object.assign({
        video: this.modalService.config.initialState?.video
      });
    }

    // this.loadFfmpeg();
  }
  ngAfterViewInit() {
    if (this.modalInfo?.video?.file)
      this.videoElement.nativeElement.src = this.modalInfo.video.file;

    this.videoElement.nativeElement.load();
    setTimeout(() => {
      this.extractFrames();
    }, 0);
  }

  onEmitWatermarkChange($event) {
    this.watermark = $event.watermark;
    this.onEmitApplyGlobalWatermark($event.watermarkSettings);
  }

  onEmitApplyGlobalWatermark(watermarkSettings) {
    this.watermarkSettings.globalWatermark = {
      ...this.watermarkSettings.globalWatermark,
      ...watermarkSettings,
      apply_watermark: this.watermark
    }
    this.watermarkChange.emit(this.watermarkSettings.globalWatermark);
  }

  onFileSelected(event, isMobileApp = false) {
    if (isMobileApp) {
      const files = event?.map(fileObj => base64ToImage(fileObj.uri, fileObj.fileName));
      this.handleOnFileSelected(files);
    } else {
      this.handleOnFileSelected(event.target.files);
    }
  }

  handleOnFileSelected(files) {
    if (files && files.length > 0) {
      let file = files[0];
  
      this.uploadService.checkAndConvertHeicOrAvifToJpeg(file).then((convertedFile) => {
        const reader = new FileReader();
        reader.onload = (e: ProgressEvent<FileReader>) => {
          const image = new Image();
          image.src = e.target?.result as string;
          image.onload = (le: any) => {
            const newEvent = le.path || (le.composedPath && le.composedPath());
            const imageWidth = newEvent[0].naturalWidth;
            const imageHeight = newEvent[0].naturalHeight;
            const imageMode =
              imageWidth > imageHeight
                ? Application.LANDSCAPE
                : Application.PORTRAIT;
  
            if (this.videoMode !== imageMode) {
              this.cs.showErrorMessage(
                Application.VIDEO_COVER_ORIENTATION_MATCH_ERROR
              );
              return;
            }
            const payload = {
              index: this.cs.getUuid(),
              src: e.target?.result as string
            };
            this.setCoverImage(payload);
          };
        };
  
        reader.readAsDataURL(convertedFile);
      }).catch(() => {
      });
    }
  }
  

  extractFrames() {
    const video = this.videoElement.nativeElement;
    const canvas = this.canvasElement.nativeElement;
    const context = canvas.getContext('2d');

    if (!context) {
      console.error('Failed to get canvas context');
      return;
    }

    // Listen for the loadedmetadata event before accessing video properties
    video.onloadedmetadata = () => {
      const duration = video.duration;
      const totalFramesToExtract = 5; // Number of frames to extract
      const interval = duration / totalFramesToExtract; // Calculate time intervals

      this.frameArray = []; // Reset frames
      let currentFrameIndex = 0; // Keep track of the current frame index

      const extractNextFrame = () => {
        if (currentFrameIndex < totalFramesToExtract) {
          const time = currentFrameIndex * interval; // Calculate the time for the current frame
          video.currentTime = time; // Seek to the calculated time

          video.onseeked = () => {
            // Set the canvas dimensions to the video dimensions
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const frameData = canvas.toDataURL('image/png');
            const payload = { index: this.cs.getUuid(), src: frameData };
            if (this.frameArray.length === 0) {
              this.setCoverImage(payload);
            }
            this.frameArray.push(payload);
            currentFrameIndex++; // Move to the next frame
            extractNextFrame(); // Extract the next frame
          };
        } else {
        }
      };

      // Start extracting frames
      extractNextFrame();
    };

    // Handle errors
    video.onerror = (err) => {

      console.error('Error loading video', err);
    };
  }

  setCoverImage(coverImage) {
    this.selectedCoverImage = coverImage;
    this.videoPlayer?.setCoverImage(coverImage.src);
  }
  trimAndUpload() {
    if (this.isConfirming) {
      return;
    }
    this.isConfirming = true;

    if (this.isWatermark) {
      this.confirmedWithWatermark.emit({
        selectedCoverImage: this.selectedCoverImage,
        watermark: this.watermark
      });
    } else {
      this.confirmed.emit(this.selectedCoverImage);
    }
    this.closeDialog();
  }

  closeDialog() {
    this.titleService.setTitle(CommonEnums.defaultTitle);
    this.modalService.hide();
  }
  cancel() {
    this.cancelled.emit();
    this.closeDialog();
  }
}
